import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { MaterialModule } from 'src/app/material.module';
import { RouterModule } from '@angular/router';
import { AnnouncementsModule } from 'src/app/shared/announcements/announcements.module';

@NgModule({
  declarations: [HomeComponent],
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    AnnouncementsModule
  ]
})
export class HomeModule { }
